import { Button, Container, Spacer, Typography } from '@ct-design/lib'
import { DeviceType } from '@/src/types'
import useTravellerInfo from '@/src/hooks/useTravellerInfo'
import ItineraryLoader from '@/src/components/desktop/itinerary/loader'
import PersonalDetails from './personalDetails'
import { isEmpty, pluralize } from '@/src/utils/helper'
import TravellerSelector from '@/src/container/common/travellerInfo/travellerSelector'

const TravellerInfoStep = ({ deviceType }: { deviceType: DeviceType }) => {
    const {
        isLoading,
        adults,
        children,
        selectedTravellerIndex,
        selectedTraveller,
        travellerDetails,
        errorFields,
        isdCode,
        phoneNumber,
        customerEmail,
        showNextButton,
        totalAmount,
        currencyCode,
        onTravellerClick,
        onFieldChange,
        updateMobileValidation
    } = useTravellerInfo({ deviceType })

    if (isLoading || isEmpty(selectedTraveller)) {
        return <ItineraryLoader />
    }
    return (
        <Container className='flex flex-column'>
            <Typography variant='HM2'>Personal Details</Typography>
            <Spacer className='mb-5' />
            {adults + children > 1 && (
                <>
                    <TravellerSelector
                        selectedTravellerIndex={selectedTravellerIndex}
                        adultCount={adults}
                        travellerCount={adults + children}
                        travellerDetails={travellerDetails}
                        onTravellerClick={onTravellerClick}
                    />
                    <Spacer className='mb-5' />
                </>
            )}

            {selectedTraveller && (
                <PersonalDetails
                    selectedTraveller={selectedTraveller}
                    onFieldChange={onFieldChange}
                    errorFields={errorFields}
                    updateMobileValidation={updateMobileValidation}
                    contactDetails={{
                        isdCode,
                        phoneNumber,
                        customerEmail
                    }}
                />
            )}
            {showNextButton && (
                <Container className='flex flex-row flex-end mt-4'>
                    <Button
                        variant='outline'
                        onClick={() => {
                            const nextTravellerIndex =
                                selectedTravellerIndex + 1
                            onTravellerClick(nextTravellerIndex)
                        }}
                    >
                        Next
                    </Button>
                </Container>
            )}

            <Container
                className='flex flex-row p-3 br-6 flex-between mt-8'
                style={{
                    backgroundColor: 'rgb(239 246 255)'
                }}
            >
                <Container className='flex flex-column py-1'>
                    <Typography variant='HM3'>
                        Price (Total for {adults + children}{' '}
                        {pluralize(adults + children, 'Traveller')}):
                    </Typography>
                    <Typography variant='HM1'>
                        {currencyCode} {totalAmount}
                    </Typography>
                </Container>
            </Container>
        </Container>
    )
}

export default TravellerInfoStep
